import { z } from 'zod';

import { EscrowSettingId } from '../BrandedIds';
import { zodTemporalPlainDate } from '../Temporal';

/**
 * The information required to determine if an borrower insurance expiration
 * email has already been enqueued.
 */
export const BorrowerInsuranceExpirationInformation = z.object({
  escrowSettingId: EscrowSettingId,
  policyEndDate: zodTemporalPlainDate,
  // The number of days before or after the policy end date an email
  // was enqueued.
  cadence: z.number().positive(),
});
export type BorrowerInsuranceExpirationInformation = z.infer<typeof BorrowerInsuranceExpirationInformation>;
